interface CsrfToken {
    csrfToken: string;
}

export const csrfToken: CsrfToken = { csrfToken: '123456' };
